import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
@Injectable()
export class ChatEffects {
  constructor(public actions$: Actions) {}
}
